// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"detail-collection-content_contentWrapper__GNM9J"};